import React, { useEffect, useRef } from 'react';
import StepShell from '../StepShell';

const formatTimer = (seconds) => {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
};

const VerifyStep = ({
  method, contact, otp, setOtp, resendSeconds, onResend, onSubmit, onBack, error, submitting,
  step = 2, totalSteps = 6,
}) => {
  const inputsRef = useRef([]);

  useEffect(() => {
    inputsRef.current[0]?.focus();
  }, []);

  const target = method === 'email' ? contact.email : `${contact.countryCode} ${contact.phone}`;
  const isComplete = otp.every((d) => d !== '');

  const handleChange = (index, rawValue) => {
    const value = rawValue.replace(/\D/g, '').slice(-1);
    const next = [...otp];
    next[index] = value;
    setOtp(next);
    if (value && index < otp.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, otp.length);
    if (!pasted) return;
    e.preventDefault();
    const next = [...otp];
    pasted.split('').forEach((digit, i) => { next[i] = digit; });
    setOtp(next);
    inputsRef.current[Math.min(pasted.length, otp.length - 1)]?.focus();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isComplete) return;
    onSubmit();
  };

  return (
    <StepShell step={step} totalSteps={totalSteps} title="Enter the code" subtitle={`We sent a 6-digit code to ${target}`} onBack={onBack}>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <div className="ob-otp-icon">🍲</div>
        <div className="ob-otp-row" onPaste={handlePaste}>
          {otp.map((digit, index) => (
            <input
              key={index}
              ref={(el) => { inputsRef.current[index] = el; }}
              type="text"
              inputMode="numeric"
              maxLength={1}
              className={`ob-otp-box${digit ? ' filled' : ''}`}
              value={digit}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
            />
          ))}
        </div>

        <div className="ob-resend">
          {resendSeconds > 0 ? (
            <>Resend code in {formatTimer(resendSeconds)}</>
          ) : (
            <button type="button" onClick={onResend}>Resend code</button>
          )}
        </div>

        {error && <p className="ob-error-text" style={{ textAlign: 'center' }}>{error}</p>}

        <div className="ob-spacer" />

        <button type="submit" className="ob-btn-primary" disabled={!isComplete || submitting}>
          {submitting ? 'Verifying…' : 'Verify'}
        </button>
      </form>
    </StepShell>
  );
};

export default VerifyStep;
